import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout route for `/r/$publicId/*`. The actual landing page (the
// "Invoice from <seller>" summary with the Sign-in-to-pay CTA) lives in
// the sibling `r.$publicId.index.tsx`; this file only renders an Outlet
// so child routes like `/r/$publicId/consume`, `/r/$publicId/kyc`,
// `/r/$publicId/tracking`, etc. take over the viewport when matched.
export const Route = createFileRoute('/r/$publicId')({
  component: () => <Outlet />,
});
